import React, { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

// --- ÖRNEK DENEME SINAVI VERİLERİ ---
const EXAM_DATA = [
  {
    id: 1,
    title: "Türkiye Geneli LGS Denemesi - 1",
    type: "Genel",
    questionCount: 90,
    duration: "155 Dk",
    difficulty: "Orta",
    status: "new", // new, solved, locked
    date: "15.01.2025",
    tags: ["Sayısal", "Sözel"]
  },
  {
    id: 2,
    title: "Fen Bilimleri 'DNA ve Kod' Tarama",
    type: "Branş",
    questionCount: 20,
    duration: "40 Dk",
    difficulty: "Kolay",
    status: "solved",
    date: "10.01.2025",
    tags: ["Fen Bilimleri"]
  },
  {
    id: 3,
    title: "Matematik 'Çarpanlar' Özel Test",
    type: "Branş",
    questionCount: 20,
    duration: "40 Dk",
    difficulty: "Zor",
    status: "new",
    date: "20.01.2025",
    tags: ["Matematik"]
  },
  {
    id: 4,
    title: "1. Dönem Tekrar Denemesi",
    type: "Genel",
    questionCount: 90,
    duration: "155 Dk",
    difficulty: "Zor",
    status: "locked",
    date: "01.02.2025",
    tags: ["Genel Tekrar"]
  },
  {
    id: 5,
    title: "İnkılap Tarihi - Bir Kahraman Doğuyor",
    type: "Branş",
    questionCount: 10,
    duration: "20 Dk",
    difficulty: "Kolay",
    status: "new",
    date: "22.01.2025",
    tags: ["İnkılap"]
  },
  {
    id: 6,
    title: "Şubat Kampı - Sayısal Deneme",
    type: "Bölüm",
    questionCount: 40,
    duration: "80 Dk",
    difficulty: "Orta-Zor",
    status: "locked",
    date: "15.02.2025",
    tags: ["Matematik", "Fen"]
  }
];

export default function LGSExamsPage() {
  const [filter, setFilter] = useState('Tümü');

  // Filtreleme Mantığı
  const filteredExams = filter === 'Tümü' 
    ? EXAM_DATA 
    : EXAM_DATA.filter(exam => exam.type === filter || exam.tags.includes(filter));

  const getDifficultyColor = (diff: string) => {
    if (diff.includes("Kolay")) return "text-green-600 bg-green-50 border-green-100";
    if (diff.includes("Zor")) return "text-red-600 bg-red-50 border-red-100";
    return "text-orange-600 bg-orange-50 border-orange-100";
  };

  return (
    <div className="min-h-screen bg-slate-50 font-poppins">
      <Navbar />

      {/* HEADER */}
      <div className="bg-[#1e293b] pt-32 pb-24 px-4 text-center rounded-b-[3rem] shadow-2xl relative overflow-hidden">
        {/* Dekoratif Arkaplan */}
        <div className="absolute top-0 left-0 w-full h-full opacity-20 pointer-events-none">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-teal-500 rounded-full blur-[100px]"></div>
          <div className="absolute top-1/2 left-0 w-72 h-72 bg-indigo-500 rounded-full blur-[80px]"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 text-teal-300 text-sm font-bold mb-6 border border-white/5 backdrop-blur-sm">
            <i className="ri-book-mark-line"></i>
            LGS Hazırlık Merkezi
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 tracking-tight">
            Deneme Sınavı <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-emerald-400">Arşivi</span>
          </h1>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Türkiye geneli denemeler, branş testleri ve konu tarama sınavlarına buradan ulaşabilir, 
            ister PDF indirip ister online çözebilirsin.
          </p>
        </div>
      </div>

      <main className="px-4 -mt-16 pb-20 relative z-20">
        <div className="max-w-6xl mx-auto">
          
          {/* FİLTRE VE İSTATİSTİK BAR */}
          <div className="bg-white rounded-2xl shadow-lg p-4 mb-8 flex flex-col md:flex-row justify-between items-center gap-4 border border-gray-100">
            {/* Sol: Filtreler */}
            <div className="flex gap-2 overflow-x-auto w-full md:w-auto pb-2 md:pb-0 scrollbar-hide">
              {['Tümü', 'Genel', 'Branş', 'Matematik', 'Fen Bilimleri'].map((item) => (
                <button
                  key={item}
                  onClick={() => setFilter(item)}
                  className={`px-5 py-2.5 rounded-xl text-sm font-bold transition-all whitespace-nowrap ${
                    filter === item 
                    ? 'bg-slate-800 text-white shadow-md' 
                    : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                  }`}
                >
                  {item}
                </button>
              ))}
            </div>

            {/* Sağ: İstatistik */}
            <div className="flex gap-6 text-sm font-medium text-gray-500 pr-4 hidden md:flex">
              <span className="flex items-center gap-1.5"><i className="ri-file-list-3-line text-indigo-500"></i> {EXAM_DATA.length} Sınav</span>
              <span className="flex items-center gap-1.5"><i className="ri-check-double-line text-emerald-500"></i> 1 Çözüldü</span>
            </div>
          </div>

          {/* SINAV LİSTESİ */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredExams.map((exam) => (
              <div key={exam.id} className="group bg-white rounded-2xl p-6 shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-100 relative overflow-hidden">
                
                {/* Durum Etiketi */}
                <div className="absolute top-4 right-4">
                  {exam.status === 'new' && <span className="bg-blue-100 text-blue-700 text-xs font-bold px-3 py-1 rounded-full animate-pulse">YENİ</span>}
                  {exam.status === 'solved' && <span className="bg-emerald-100 text-emerald-700 text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1"><i className="ri-check-line"></i> ÇÖZÜLDÜ</span>}
                  {exam.status === 'locked' && <span className="bg-gray-100 text-gray-500 text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1"><i className="ri-lock-line"></i> ERİŞİLEMEZ</span>}
                </div>

                {/* İkon ve Başlık */}
                <div className="flex items-start gap-4 mb-4 mt-2">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-2xl shrink-0 
                    ${exam.type === 'Genel' ? 'bg-indigo-50 text-indigo-600' : 'bg-teal-50 text-teal-600'}`}>
                    <i className={exam.type === 'Genel' ? "ri-honour-line" : "ri-flask-line"}></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-800 leading-tight group-hover:text-indigo-600 transition-colors">
                      {exam.title}
                    </h3>
                    <div className="text-xs text-gray-400 mt-1 font-medium">{exam.date}</div>
                  </div>
                </div>

                {/* Detaylar */}
                <div className="flex items-center gap-2 mb-6">
                  <span className="px-2.5 py-1 rounded-lg bg-gray-50 text-gray-500 text-xs font-bold border border-gray-100">
                    {exam.questionCount} Soru
                  </span>
                  <span className="px-2.5 py-1 rounded-lg bg-gray-50 text-gray-500 text-xs font-bold border border-gray-100">
                    {exam.duration}
                  </span>
                  <span className={`px-2.5 py-1 rounded-lg text-xs font-bold border ${getDifficultyColor(exam.difficulty)}`}>
                    {exam.difficulty}
                  </span>
                </div>

                {/* Butonlar */}
                <div className="grid grid-cols-2 gap-3 pt-4 border-t border-gray-50">
                  {exam.status === 'locked' ? (
                    <button disabled className="col-span-2 w-full py-2.5 bg-gray-50 text-gray-400 font-bold rounded-xl text-sm flex items-center justify-center gap-2 cursor-not-allowed">
                      <i className="ri-time-line"></i> Tarih Bekleniyor
                    </button>
                  ) : (
                    <>
                      <button className="py-2.5 bg-white border-2 border-slate-100 hover:border-slate-800 text-slate-700 hover:text-slate-900 font-bold rounded-xl text-sm transition-all flex items-center justify-center gap-2">
                        <i className="ri-download-line"></i> PDF
                      </button>
                      <button className="py-2.5 bg-slate-900 hover:bg-indigo-600 text-white font-bold rounded-xl text-sm transition-all shadow-lg shadow-slate-200 hover:shadow-indigo-200 flex items-center justify-center gap-2">
                        <i className="ri-play-circle-line"></i> Başla
                      </button>
                    </>
                  )}
                </div>

              </div>
            ))}
          </div>

          {/* BOŞ DURUM */}
          {filteredExams.length === 0 && (
            <div className="text-center py-20 bg-white rounded-2xl border border-dashed border-gray-200 mt-8">
              <div className="text-gray-300 text-5xl mb-4"><i className="ri-inbox-line"></i></div>
              <h3 className="text-lg font-bold text-gray-600">Bu kategoride sınav bulunamadı.</h3>
              <p className="text-gray-400 text-sm">Filtreleri değiştirerek tekrar deneyebilirsin.</p>
            </div>
          )}

        </div>
      </main>

      <Footer />
    </div>
  );
}